import { api } from '@services';

interface IInviteSendAdm {
  email: string;
  role: string;
  studioId: string;
}

const inviteSendAdm = async (data: IInviteSendAdm): Promise<void> => {
  await api.post('/invites/sendAdm', data);
};

export { inviteSendAdm };
